import { useEffect, useState } from "react";

export const useAudio = (
  audioUrl: string,
  currentAudio: HTMLAudioElement | null,
  setCurrentAudio: (audio: HTMLAudioElement | null) => void,
  currentPlayingURL: string | null,
  setCurrentPlayingURL: (url: string | null) => void
) => {
  const [audio, setAudio] = useState(new Audio(audioUrl));
  const isPlaying = currentPlayingURL === audioUrl;

  useEffect(() => {
    setAudio(new Audio(audioUrl));
  }, [audioUrl]);

  const toggleAudioPlaying = () => {
    if (currentAudio && currentAudio !== audio) {
      currentAudio.pause();
      setCurrentAudio(null);
      setCurrentPlayingURL(null);
    }

    if (!isPlaying) {
      audio.play();
      setCurrentAudio(audio);
      setCurrentPlayingURL(audioUrl);
    } else {
      audio.pause();
      setCurrentAudio(null);
      setCurrentPlayingURL(null);
    }
  };

  useEffect(() => {
    audio.addEventListener("ended", () => {
      setCurrentPlayingURL(null);
      setCurrentAudio(null);
    });

    return () => {
      audio.pause();
      audio.removeEventListener("ended", () => {
        setCurrentPlayingURL(null);
        setCurrentAudio(null);
      });
    };
  }, [audio, setCurrentAudio, setCurrentPlayingURL]);

  return { isPlaying, toggleAudioPlaying };
};
